import Sidebar from "components/sidebar/Sidebar";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import routes from "routes.js";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const [loginUserType] = useState(useSelector((state) => state.authReducer).data?.user?.role);
  
  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      
      // Exclude the Company List route for company_admin users
      if (loginUserType === 'company_admin' && prop.path === '/company-management') {
        return null; // Skip this route
      }
      
      if (loginUserType !== 'super_admin' && prop.path === '/setting') {
        return null; // Skip this route
      }

      // Only render routes with layout "/admin"
      if (prop.layout === "/admin") {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null; // Skip non-admin routes
      }
    });
  };

  // Filter routes for the sidebar
  const filteredRoutes = routes.filter((route) => {
    if (loginUserType === 'company_admin' && route.path === '/company-management') {
      return false; // Exclude this route
    }
    if (loginUserType !== 'super_admin' && route.path === '/setting') {
      return false; // Exclude this route
    }
    return true; // Include all other routes
  });

  return (
    <>
      <Sidebar
        {...props}
        routes={filteredRoutes} // Pass filtered routes to the Sidebar
        logo={{
          innerLink: "/admin/index",
          imgSrc: '',
          imgAlt: "...",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/admin/index" replace />} />
        </Routes>
      </div>
    </>
  );
};

export default Admin;
